import { render, staticRenderFns } from "./staff-lists.vue?vue&type=template&id=21749ec2&"
import script from "./staff-lists.vue?vue&type=script&lang=js&"
export * from "./staff-lists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports